type array = any[];

export default function useFilter(searchTerm: string, property: string, ...lists: array[]): array[] {
	return lists.map((list) => {
		return list.filter(({ [property]: name }) => {
			return name.toLowerCase().includes(searchTerm.toLowerCase());
		});
	});
}
